import { takeWhile2lajz05xm93j8 as takeWhile } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Limit.mjs';
import { collect2p01yx803enkx as collect } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Collect.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *waitForNetwork(_this__u8e3s4, $completion) {
  var tmp = _this__u8e3s4.c63();
  yield* collect(takeWhile(tmp, waitForNetwork$slambda()), $completion);
  return Unit_instance;
}
function waitForNetwork$slambda() {
  return constructCallableReference(function *(it, $completion) {
    return !(it === true);
  }, 1);
}
//region block: exports
export {
  waitForNetwork as waitForNetworkf4ygunw90mrf,
};
//endregion

//# sourceMappingURL=NetworkMonitor.mjs.map
